const ClientRegistryStatus = {
	PENDING: 'Pending',
	ACCEPTED: 'Accepted',
	REJECTED: 'Rejected'
};

export default ClientRegistryStatus;
